module.exports = __webpack_public_path__ + "static/media/calorieTracker_logo.b1fbf988.png";